import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
// import Personnel from 'src/models/personnel/Personnel';
// import useFetch from 'use-http';
import _ from 'lodash';
import 'src/styles/pages/_accountsPayable.scss';
import Landman from '../../../models/Landman';

interface IFindManagerDialogProps {
    dialogName: string;
    handleSelectedManager?: (manager: Landman) => void;
    hideDialog: () => void;
    populateManagerList: () => void;
    managerList: Array<Landman>;
    setManagerSearchTerm?: (keyword: string) => void;
}

const FindManagerDialog = (props: IFindManagerDialogProps) => {
    // const { get, response } = useFetch();
    const { register, errors, getValues } = useForm();
    const [selectedManager, setSelectedManager] = useState<Landman>(undefined);
    const [managerSearchResults, setManagerSearchResults] = useState<Array<Landman>>(undefined);

    useEffect(() => {
        onCreate();
        props.populateManagerList();
    }, []);

    useEffect(() => {
        setManagerSearchResults(props.managerList);
    }, [props.managerList]);

    useEffect(() => {
        if (managerSearchResults) {
            console.log('PersonnelSearchResults Updated', managerSearchResults);
        }
    }, [managerSearchResults]);

    const onCreate = () => {
        // getPersonnel();
        console.log('FindPersonDialog onCreate()');
    };

    const OKClicked = () => {
        props.handleSelectedManager(selectedManager);
        props.hideDialog();
    };

    const stageManagerUpdate = (manager: Landman) => {
        props.handleSelectedManager(manager);
        props.hideDialog();
    };

    const search = _.debounce(() => {
        let searchName = getValues()?.search;
        props.setManagerSearchTerm(searchName);
    }, 800);

    /**
     * Gets the list of Personnel Users and stores in personnelList
     */
/*     const getPersonnel = async () => {
        let result = await get(`/v1.0/landmen`);
        if (response.ok && result) {
            setPersonnelList(result.items);
            setPersonnelSearchResults(result.items);
        } else {
            console.log('Unable to get the Personnel Data!!! >:c');
        }
    }; */

    return (
        <Dialog title="Find Person" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '55%' }}>
            <div className="form-row" style={{marginTop: '1rem'}}>
                <RHFInputBox labelOnLeft={true} label="Last Name" name={'search'} register={register} errors={errors} style={{width: '70%'}} onChange={() => search()}/>
                <RHFSelect 
                    name={`display`}
                    placeholder="Display Type"
                    options={[
                        { value: 'all', label: 'All' },
                        { value: 'active', label: 'Active' },
                        { value: 'inactive', label: 'Inactive' },
                    ]}
                    style={{width: '100%', border: '.5px solid LightGray', borderRadius: '5px'}}
                    // onChange={() => filter()}
                    bodyStyle={{width: '18%', marginLeft: '2rem'}}
                    register={register} 
                    errors={errors}
                />
            </div>
            <div style={{marginTop: '3rem', overflowY: 'scroll', height: '20rem'}}>
                <form>
                    <table>
                        <thead style={{ textAlign: 'center' }}>
                            <tr>
                                <th className="find-person-header" style={{ width: '12%' }}>Last Name</th>
                                <th className="find-person-header" style={{ width: '12%' }}>First Name</th>
                                <th className="find-person-header" style={{ width: '6%' }}>LM #</th>
                                <th className="find-person-header" style={{ width: '5%' }}>CL #</th>
                                <th className="find-person-header" style={{ width: '25%' }}>Client or Company Name</th>
                                <th className="find-person-header" style={{ width: '19%' }}>City</th>
                                <th className="find-person-header" style={{ width: '5%' }}>State</th>
                                <th className="find-person-header" style={{ width: '14%' }}>Type</th>
                            </tr>
                        </thead>
                        {managerSearchResults?.map((manager: Landman, index: number) => {
                            return (
                                <tbody key={manager.id}>
                                    <tr 
                                        className="table-item-hover" 
                                        style={manager?.id === selectedManager?.id ? { background: 'yellow', textAlign: 'left' } : { textAlign: 'left' }} 
                                        onClick={() => setSelectedManager(manager)}
                                        onDoubleClick={() => stageManagerUpdate(manager)}
                                    >
                                        <td style={{ width: '12%' }}>
                                            <label>{manager?.lastName}</label>
                                        </td>
                                        <td style={{ width: '12%' }}>
                                            <label>{manager?.firstName}</label>
                                        </td>
                                        <td style={{ width: '6%' }}>
                                            <label>{manager.lmsNumber}</label>
                                        </td>
                                    </tr>
                                </tbody>
                                );
                            })}
                    </table>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '12%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '12%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default FindManagerDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/FindManagerDialog.tsx